module.exports = __webpack_public_path__ + "media/images/athletes/4337-9ceb0d00fb35c8bd60517b493ced341c.png";